import React, { useState } from 'react';

function Homepage_Services() {
  const [openService, setOpenService] = useState(null);

  const services = [
    {
      title: "Customer Service",
      items: [
        "Responding to customer inquiries",
        "Managing customer feedback",
        "Order processing and tracking"
      ]
    },
    {
      title: "Social Media Management",
      items: [
        "Content creation and scheduling",
        "Engagement monitoring",
        "Basic analytics reporting"
      ]
    },
    {
      title: "Content Creation",
      items: [
        "Basic blog post writing",
        "Newsletter drafting",
        "Basic graphic design (using templates)"
      ]
    },
    {
      title: "Research and Analysis",
      items: [
        "Market research",
        "Competitor analysis",
        "Data compilation and reporting"
      ]
    }
  ];

  const toggleService = (index) => {
    setOpenService(openService === index ? null : index);
  };

  return (
    <section className="services">
      <div className="services-content">
        <h2>
          TIME TO <span className="highlight">DELEGATE</span><br />
          LIKE A BOSS AND<br />
          FOCUS ON MORE<br />
          IMPORTANT THINGS.
        </h2>
        <div className="service-list">
          {services.map((service, index) => (
            <div key={index} className="service-item">
              <div className={`service-box ${openService === index ? 'open' : ''}`} onClick={() => toggleService(index)}>
                <h3>
                  {service.title}
                  <svg className="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M7 10l5 5 5-5z" fill="#FFFF00" stroke="#000000" strokeWidth="2"/>
                  </svg>
                </h3>
              </div>
              {openService === index && (
                <ul className="service-dropdown">
                  {service.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Homepage_Services;